import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const companyDocumentsTypeChoices = makeChoicesCommon()({
  other: 'resources.bo_common.b2b.documents.choices.type.other',
  sepa_mandate_rib: 'resources.bo_common.b2b.documents.choices.type.sepa_mandate_rib',
  b2b_business_sepa_mandate_form_signed:
    'resources.bo_common.b2b.documents.choices.type.b2b_business_sepa_mandate_form_signed',
  b2b_business_sepa_mandate_form_unsigned:
    'resources.bo_common.b2b.documents.choices.type.b2b_business_sepa_mandate_form_unsigned',
  csg_crds_monthly_summary:
    'resources.bo_common.b2b.documents.choices.type.csg_crds_monthly_summary',
  csg_crds_annual_summary: 'resources.bo_common.b2b.documents.choices.type.csg_crds_annual_summary',
  campaign_operation_summary:
    'resources.bo_common.b2b.documents.choices.type.campaign_operation_summary',
  campaign_fund_request: 'resources.bo_common.b2b.documents.choices.type.campaign_fund_request',
  matching_contribution_fund_request:
    'resources.bo_common.b2b.documents.choices.type.matching_contribution_fund_request',
  in_transfer_report: 'resources.bo_common.b2b.documents.choices.type.in_transfer_report',
  out_transfer_report: 'resources.bo_common.b2b.documents.choices.type.out_transfer_report',
  transfer_in_termination_letter:
    'resources.bo_common.b2b.documents.choices.type.transfer_in_termination_letter',
  transfer_out_termination_letter:
    'resources.bo_common.b2b.documents.choices.type.transfer_out_termination_letter',
  similar_contract_certificate_document:
    'resources.bo_common.b2b.documents.choices.type.similar_contract_certificate_document',
  employee_positions_list: 'resources.bo_common.b2b.documents.choices.type.employee_positions_list',
  employee_data_fress: 'resources.bo_common.b2b.documents.choices.type.employee_data_fress',
  company_rib_document: 'resources.bo_common.b2b.documents.choices.type.company_rib_document',
  employees_bulk_create: 'resources.bo_common.b2b.documents.choices.type.employees_bulk_create',
  b2b_admin_welcome_letter:
    'resources.bo_common.b2b.documents.choices.type.b2b_admin_welcome_letter',
  b2b_pricing: 'resources.bo_common.b2b.documents.choices.type.b2b_pricing',
  b2b_admin_third_party_mandate:
    'resources.bo_common.b2b.documents.choices.type.b2b_admin_third_party_mandate',
});
